import { useEffect } from 'react'
import { useOptionalCommands } from './CommandContext.js'

// Refresh closures after each render so commands use the current pane/state.
// Owners only register while their control is available; teardown unregisters.
export function useCommandHandlers(handlers) {
  const commands = useOptionalCommands()
  useEffect(() => {
    if (!commands) return undefined
    const dispose = Object.entries(handlers).map(([id, handler]) => commands.registerCommandHandler(id, handler))
    return () => dispose.forEach(unregister => unregister())
  })
}
export default function CommandHandlers({ handlers }) {
  useCommandHandlers(handlers)
  return null
}
